const select_Quote_Type = [
  {
    value: 1,
    label: "Package (Customisable) (Single/Multiple)",
  },
  {
    value: 2,
    label: "Packaged (Standard) (Single/Multiple)",
  },
  {
    value: 3,
    label: "Custom (Single)",
  },
];
const feeInProposal = [
  {
    value: 1,
    label: "Show Full Breakdown",
  },
  {
    value: 2,
    label: "Show Totals Only",
  },
];

const Payment_Frequency = [
  {
    value: 1,
    label: "Yearly",
  },
  {
    value: 2,
    label: "Half Yearly",
  },
  {
    value: 3,
    label: "Quarterly",
  },
  {
    value: 4,
    label: "Monthly",
  },
];
const VAT_Registered = [
  {
    value: 0,
    label: "Yes",
  },
  {
    value: 1,
    label: "No",
  },
];
const FontFamily = [
  {
    value: 1,
    label: "Georgia, serif",
  },
  {
    value: 2,
    label: "Arial, sans-serif",
  },
  {
    value: 3,
    label: "Verdana, sans-serif",
  },
  {
    value: 4,
    label: "Times New Roman, serif",
  },
  {
    value: 5,
    label: "Courier New, monospace",
  },
  {
    value: 6,
    label: "Roboto, sans-serif",
  },
  {
    value: 7,
    label: "Open Sans, sans-serif",
  },
  {
    value: 8,
    label: "Lora, serif",
  },
  {
    value: 9,
    label: "Montserrat, sans-serif",
  },
  {
    value: 10,
    label: "Helvetica, sans-serif",
  },
];

const FontSize = [
  { value: 5, label: "5px" },
  { value: 6, label: "6px" },
  { value: 7, label: "7px" },
  { value: 10, label: "10px" },
  { value: 12, label: "12px" },
  { value: 14, label: "14px" },
  { value: 16, label: "16px" },
  { value: 18, label: "18px" },
  { value: 20, label: "20px" },
  { value: 24, label: "24px" },
  { value: 30, label: "30px" },
  { value: 36, label: "36px" },
  { value: 48, label: "48px" },
];
export default {
  FontSize,
  FontFamily,
  select_Quote_Type,
  feeInProposal,
  Payment_Frequency,
  VAT_Registered,
};
